export function transformObjectEntryArrayToObject(arr: { key: string; value: any }[]) {
    const obj = {} as any;
    arr.forEach((item: { key: string; value: any }) => {
        obj[item.key] = item.value;
    });
    return obj;
}

export function removeEmptyKeysFromFilters(filters: { [key: string]: any }) {
    const conversedFilters = { ...filters };
    Object.keys(conversedFilters).forEach((filterKey) => {
        if (filterKey === "") {
            delete (conversedFilters as any)?.[""];
        }
        if (conversedFilters[filterKey] === "" || conversedFilters[filterKey] === undefined) {
            delete (conversedFilters as any)?.[filterKey];
        }
        if (conversedFilters[filterKey] === "tab") {
            delete (conversedFilters as any)?.["tab"];
        }
    });
    return conversedFilters;
}

export interface ObjectItem<T> {
    id: T;
    name: string;
    type?: string;
}

export const merge = (a: any, b: any[], predicate = (a: any, b: any) => a === b) => {
    const c = [...a]; // copy to avoid side effects
    // add all items from B to copy C if they're not already present
    b.forEach((bItem: any) => (c.some((cItem) => predicate(bItem, cItem)) ? null : c.push(bItem)));
    return c;
};

type ObjectWithNestedValues = { [key: string]: any };

export function getObjectPaths(obj: ObjectWithNestedValues, parentPath?: string): string[] {
    let paths: string[] = [];

    for (const key in obj) {
        if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
            const nestedPaths = getObjectPaths(obj[key], `${parentPath}${key}.`);
            paths = paths.concat(nestedPaths);
        } else if (Array.isArray(obj[key])) {
            for (let i = 0; i < obj[key].length; i++) {
                const value = obj[key][i];
                if (typeof value === "string") {
                    paths.push(`${parentPath}${key}.[${i}]`);
                } else if (typeof value === "object") {
                    const nestedPaths = getObjectPaths(value, `${parentPath}${key}.[${i}].`);
                    paths = paths.concat(nestedPaths);
                }
            }
        } else if (typeof obj[key] === "string") {
            paths.push(`${parentPath}${key}`);
        }
    }

    return paths;
}

export function getValueByPath(obj: ObjectWithNestedValues, path: string): any {
    const keys: string[] = path.split(".");
    let value: any = obj;

    for (const key of keys) {
        if (value && typeof value === "object") {
            const match = key.match(/^\[(\d+)\]$/);
            if (match) {
                const index: number = parseInt(match[1]);
                value = value[index];
            } else {
                value = value[key];
            }
        } else {
            return undefined;
        }
    }

    return value;
}
